import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes } from 'maestro-ng';
import { FonteDadosMensagemErroService } from '../../fonte-dados/fonte-dados-mensagem-erro.service';
import { FonteDados } from '../../fonte-dados/fonte-dados.model';
import { DataSourceRouted } from '../../util/data-source-routed';
import { TipoParteLocal } from '../tipo-parte-local.model';
import { TipoParteLocalService } from '../tipo-parte-local.service';

@Component({
  selector: 'app-tipo-parte-local-lista',
  templateUrl: './tipo-parte-local-lista.component.html',
  styleUrls: ['./tipo-parte-local-lista.component.css'],
})
export class TipoParteLocalListaComponent implements OnInit, OnChanges {
  @Input()
  fonteDados: FonteDados;

  public ds: DataSourceRouted<TipoParteLocal, number>;

  constructor(
    private service: TipoParteLocalService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private route: ActivatedRoute,
    private router: Router,
    private fonteDadosMensagemErroService: FonteDadosMensagemErroService
  ) {
    this.ds = new DataSourceRouted<TipoParteLocal, number>(
      'fonte-dados-depara-tipo-parte',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([
        new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
        new Restricao<number>({ atributo: 'fonteDados.id', operador: RestricaoOperador.EQUALS }),
        new Restricao<string>({ atributo: 'origemId', operador: RestricaoOperador.EQUALS }),
        new Restricao<string>({ atributo: 'nome', operador: RestricaoOperador.CONTAINS }),
        new Restricao<string>({ atributo: 'tipoParte.nome', operador: RestricaoOperador.CONTAINS }),
      ])
    );
  }

  ngOnInit(): void {}

  ngOnChanges(_: SimpleChanges): void {
    if (this.fonteDados !== undefined && this.fonteDados?.id !== undefined) {
      this.ds.restricoes.atributo('fonteDados.id').valor = this.fonteDados.id;
      this.ds.pesquisar();
    }
  }

  sincronizar(): void {
    this.progressoService.modal();
    this.service
      .sincronizar(this.fonteDados)
      .then(() => {
        this.mensagemService.addSucesso('Sucesso', 'Os Tipos de partes foram sincronizados com sucesso!');
        this.ds.atualizar();
        this.progressoService.fechar();
      })
      .catch((response) => {
        this.ds.atualizar();
        this.progressoService.fechar();
        this.fonteDadosMensagemErroService.apresentarErro(
          'Erro ao sincronizar os Tipos de partes da fonte de dados',
          'Sincronizar tipos de partes',
          response
        );
      });
  }
}
